<template>
    <div
        class="mt-8 bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10 max-w-md mx-auto"
    >
        <form @submit.prevent="register">
            <div class="grid grid-cols-1 gap-y-4 gap-x-4 sm:grid-cols-6">
                <div class="col-span-6">
                    <label
                        for="name"
                        class="block text-sm font-medium text-gray-700"
                    >
                        Name
                    </label>
                    <div class="mt-1 relative">
                        <input
                            @input="form.errors.name = ''"
                            v-model="form.name"
                            type="text"
                            name="name"
                            id="name"
                            autocomplete="name"
                            class="shadow-sm block w-full sm:text-sm rounded-md"
                            :class="
                                form.errors.name
                                    ? 'border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500'
                                    : 'focus:ring-blue-500 focus:border-blue-500 border-gray-300'
                            "
                        />
                        <div
                            v-if="form.errors.name"
                            class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                        >
                            <ExclamationCircleIcon
                                class="h-5 w-5 text-red-500"
                            />
                        </div>
                    </div>
                    <p
                        v-if="form.errors.name"
                        class="mt-2 text-sm text-red-600"
                    >
                        {{ form.errors.name }}
                    </p>
                </div>

                <div class="sm:col-span-6">
                    <label
                        for="email"
                        class="block text-sm font-medium text-gray-700"
                    >
                        Email address
                    </label>
                    <div class="mt-1 relative">
                        <input
                            @input="form.errors.email = ''"
                            v-model="form.email"
                            id="email"
                            name="email"
                            type="email"
                            autocomplete="email"
                            class="shadow-sm block w-full sm:text-sm rounded-md"
                            :class="
                                form.errors.name
                                    ? 'border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500'
                                    : 'focus:ring-blue-500 focus:border-blue-500 border-gray-300'
                            "
                        />
                        <div
                            v-if="form.errors.email"
                            class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                        >
                            <ExclamationCircleIcon
                                class="h-5 w-5 text-red-500"
                            />
                        </div>
                    </div>
                    <p
                        v-if="form.errors.email"
                        class="mt-2 text-sm text-red-600"
                    >
                        {{ form.errors.email }}
                    </p>
                </div>

                <div class="col-span-6">
                    <label
                        for="password"
                        class="block text-sm font-medium text-gray-700"
                    >
                        Password
                    </label>
                    <div class="mt-1 relative">
                        <input
                            @input="form.errors.password = ''"
                            v-model="form.password"
                            type="password"
                            name="password"
                            id="password"
                            autocomplete="password"
                            class="shadow-sm block w-full sm:text-sm rounded-md"
                            :class="
                                form.errors.name
                                    ? 'border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500'
                                    : 'focus:ring-blue-500 focus:border-blue-500 border-gray-300'
                            "
                        />
                        <div
                            v-if="form.errors.password"
                            class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                        >
                            <ExclamationCircleIcon
                                class="h-5 w-5 text-red-500"
                            />
                        </div>
                    </div>
                    <p
                        v-if="form.errors.password"
                        class="mt-2 text-sm text-red-600"
                    >
                        {{ form.errors.password }}
                    </p>
                </div>

                <div class="col-span-6">
                    <label
                        for="password_confirmation"
                        class="block text-sm font-medium text-gray-700"
                    >
                        Confirm Password
                    </label>
                    <div class="mt-1 relative">
                        <input
                            @input="form.errors.password_confirmation = ''"
                            v-model="form.password_confirmation"
                            type="password"
                            name="password_confirmation"
                            id="password_confirmation"
                            autocomplete="password_confirmation"
                            class="shadow-sm block w-full sm:text-sm rounded-md"
                            :class="
                                form.errors.name
                                    ? 'border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500'
                                    : 'focus:ring-blue-500 focus:border-blue-500 border-gray-300'
                            "
                        />
                        <div
                            v-if="form.errors.password_confirmation"
                            class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                        >
                            <ExclamationCircleIcon
                                class="h-5 w-5 text-red-500"
                            />
                        </div>
                    </div>
                    <p
                        v-if="form.errors.password_confirmation"
                        class="mt-2 text-sm text-red-600"
                    >
                        {{ form.errors.password_confirmation }}
                    </p>
                </div>

                <div class="col-span-6">
                    <label
                        for="phone_number"
                        class="block text-sm font-medium text-gray-700"
                    >
                        Phone Number
                    </label>
                    <div class="mt-1 relative">
                        <input
                            @input="form.errors.phone_number = ''"
                            v-model="form.phone_number"
                            type="text"
                            name="phone_number"
                            id="phone_number"
                            autocomplete="phone_number"
                            class="shadow-sm block w-full sm:text-sm rounded-md"
                            :class="
                                form.errors.name
                                    ? 'border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500'
                                    : 'focus:ring-blue-500 focus:border-blue-500 border-gray-300'
                            "
                        />
                        <div
                            v-if="form.errors.phone_number"
                            class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                        >
                            <ExclamationCircleIcon
                                class="h-5 w-5 text-red-500"
                            />
                        </div>
                    </div>
                    <p
                        v-if="form.errors.phone_number"
                        class="mt-2 text-sm text-red-600"
                    >
                        {{ form.errors.phone_number }}
                    </p>
                </div>

                <div class="col-span-6">
                    <label
                        for="zip"
                        class="block text-sm font-medium text-gray-700"
                    >
                        ZIP / Postal
                    </label>
                    <div class="mt-1 relative">
                        <input
                            @input="form.errors.zipcode = ''"
                            v-model="form.zipcode"
                            type="text"
                            name="zip"
                            id="zip"
                            autocomplete="postal-code"
                            class="shadow-sm block w-full sm:text-sm rounded-md"
                            :class="
                                form.errors.name
                                    ? 'border-red-300 text-red-900 placeholder-red-300 focus:outline-none focus:ring-red-500 focus:border-red-500'
                                    : 'focus:ring-blue-500 focus:border-blue-500 border-gray-300'
                            "
                        />
                        <div
                            v-if="form.errors.zipcode"
                            class="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none"
                        >
                            <ExclamationCircleIcon
                                class="h-5 w-5 text-red-500"
                            />
                        </div>
                    </div>
                    <p
                        v-if="form.errors.zipcode"
                        class="mt-2 text-sm text-red-600"
                    >
                        {{ form.errors.zipcode }}
                    </p>
                </div>
            </div>
            <div class="flex items-center justify-end pt-4">
                <div class="text-sm">
                    <a
                        :href="route('login.show')"
                        class="font-medium text-blue-600 hover:text-blue-500"
                    >
                        Have an account login ?
                    </a>
                </div>
            </div>

            <div class="pt-8">
                <button
                    type="submit"
                    class="w-full inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
                >
                    Register
                </button>
            </div>

            <p class="mt-4">
                <small
                    >This site is protected by reCAPTCHA and the Google
                    <a
                        class="underline font-medium"
                        href="https://policies.google.com/privacy"
                        >Privacy Policy</a
                    >
                    and
                    <a
                        class="underline font-medium"
                        href="https://policies.google.com/terms"
                        >Terms of Service</a
                    >
                    apply.
                </small>
            </p>
        </form>
    </div>
</template>

<script>
// import { useReCaptcha } from "vue-recaptcha-v3";
import { useForm } from "@inertiajs/inertia-vue3";
import { ExclamationCircleIcon } from "@heroicons/vue/solid";

export default {
    setup() {
        // const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

        const form = useForm({
            name: "",
            email: "",
            password: "",
            password_confirmation: "",
            phone_number: "",
            zipcode: "",
            "g-recaptcha-response": "",
        });

        const route = window.route;

        const register = async () => {
            // await recaptchaLoaded();

            // form["g-recaptcha-response"] = await executeRecaptcha("register");

            form.post(route("register"));
        };

        return { form, register, route };
    },

    components: {
        ExclamationCircleIcon,
    },
};
</script>
